import { Vehicle, Booking, RentalLocation, RentalAddOn, RentalClient, FleetExpense } from '@/types';

// Fleet mirrors the live listing of BGR Cars Agadir (bgr-cars.com/cars):
// Logan, Sandero, Sandero Stepway, Clio 5 (×2 incl. auto), Picanto, i10,
// Accent, 208, Jogger 7 places, Sportage, T-Roc — with their DH/day prices.
// Demo photos: Wikimedia Commons (CC BY-SA, e.g. Matti Blume / Alexander Migl).
// Agencies must replace them with their own shots via Fleet → Edit → Photos.
export const INITIAL_VEHICLES: Vehicle[] = [
  {
    id: 'car-1',
    name: 'Dacia Logan',
    brand: 'Dacia',
    model: 'Logan',
    category: 'Economy',
    pricePerDay: 250,
    seats: 5,
    transmission: 'Manual',
    bags: 4,
    fuelType: 'Diesel',
    mpg: '4.5 L/100km',
    rating: 4.8,
    reviewsCount: 142,
    licensePlate: '18453-A-27',
    status: 'available',
    mileage: 45200,
    features: ['Climatisation', 'Bluetooth', 'Régulateur de vitesse', 'Caméra de recul'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/2023%20Dacia%20Logan%20III%20IMG%209671.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/2023%20Dacia%20Logan%20III%20IMG%209671.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/2023%20Dacia%20Logan%20III%20IMG%209678.jpg?width=800',
    ],
    colorName: 'Gris Comète',
    year: 2023,
    highlight: true,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-03-15',
    assuranceExpiry: '2026-12-31',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 40000,
    nextVidangeKm: 50000,
  },
  {
    id: 'car-2',
    name: 'Dacia Sandero',
    brand: 'Dacia',
    model: 'Sandero',
    category: 'Economy',
    pricePerDay: 250,
    seats: 5,
    transmission: 'Manual',
    bags: 3,
    fuelType: 'Gasoline',
    mpg: '5.1 L/100km',
    rating: 4.7,
    reviewsCount: 98,
    licensePlate: '39271-B-12',
    status: 'available',
    mileage: 38400,
    features: ['Climatisation', 'Bluetooth', 'Vitres électriques', 'Airbag'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/2023%20Dacia%20Sandero%20III%201X7A6192.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/2023%20Dacia%20Sandero%20III%201X7A6192.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Dacia%20Sandero%20III%201X7A0329.jpg?width=800',
    ],
    colorName: 'Blanc Glacier',
    year: 2023,
    highlight: true,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-01-20',
    assuranceExpiry: '2026-11-30',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 30000,
    nextVidangeKm: 40000,
  },
  {
    id: 'car-3',
    name: 'Dacia Sandero Stepway',
    brand: 'Dacia',
    model: 'Sandero Stepway',
    category: 'Economy',
    pricePerDay: 280,
    seats: 5,
    transmission: 'Automatic',
    bags: 3,
    fuelType: 'Gasoline',
    mpg: '5.4 L/100km',
    rating: 4.8,
    reviewsCount: 76,
    licensePlate: '44710-A-33',
    status: 'available',
    mileage: 21500,
    features: ['Climatisation auto', 'Apple CarPlay', 'Caméra de recul', 'Toit ouvrant'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/2024%20Dacia%20Sandero%20III%20GIMS%202024%201X7A2018.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/2024%20Dacia%20Sandero%20III%20GIMS%202024%201X7A2018.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Dacia%20Sandero%20III%201X7A0343.jpg?width=800',
    ],
    colorName: 'Orange Terracotta',
    year: 2024,
    highlight: true,
    location: 'Agadir City Center',
    visiteTechniqueExpiry: '2027-06-10',
    assuranceExpiry: '2027-02-15',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 15000,
    nextVidangeKm: 25000,
  },
  {
    id: 'car-4',
    name: 'Renault Clio 5',
    brand: 'Renault',
    model: 'Clio V',
    category: 'Economy',
    pricePerDay: 300,
    seats: 5,
    transmission: 'Manual',
    bags: 3,
    fuelType: 'Diesel',
    mpg: '4.2 L/100km',
    rating: 4.9,
    reviewsCount: 164,
    licensePlate: '52108-B-41',
    status: 'reserved',
    mileage: 52300,
    features: ['Climatisation', 'Régulateur adaptatif', 'Aide au stationnement', 'Bluetooth'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Renault%20Clio%20V%20(2023)%201X7A1577.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/Renault%20Clio%20V%20(2023)%201X7A1577.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Renault%20Clio%20R.S.%20Line%20(V)%20%E2%80%93%20f%2017102021.jpg?width=800',
    ],
    colorName: 'Gris Titanium',
    year: 2023,
    highlight: true,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2026-10-28',
    assuranceExpiry: '2027-04-01',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 45000,
    nextVidangeKm: 55000,
  },
  {
    id: 'car-5',
    name: 'Renault Clio 5 Auto',
    brand: 'Renault',
    model: 'Clio V E-Tech',
    category: 'Economy',
    pricePerDay: 300,
    seats: 5,
    transmission: 'Automatic',
    bags: 3,
    fuelType: 'Gasoline',
    mpg: '4.8 L/100km',
    rating: 4.9,
    reviewsCount: 87,
    licensePlate: '61042-A-18',
    status: 'available',
    mileage: 18900,
    features: ['Boîte auto', 'Climatisation auto', 'Caméra 360°', 'Sièges chauffants'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Renault%20Clio%20V%20(2023)%20Esprit%20Alpine%20Automesse%20Ludwigsburg%202023%201X7A0012.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/Renault%20Clio%20V%20(2023)%20Esprit%20Alpine%20Automesse%20Ludwigsburg%202023%201X7A0012.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Renault%20Clio%20V%20(2023)%20Esprit%20Alpine%20Automesse%20Ludwigsburg%202023%201X7A0088.jpg?width=800',
    ],
    colorName: 'Blanc Nacré',
    year: 2024,
    highlight: false,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-09-01',
    assuranceExpiry: '2027-05-20',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 10000,
    nextVidangeKm: 20000,
  },
  {
    id: 'car-6',
    name: 'Kia Picanto',
    brand: 'Kia',
    model: 'Picanto GT-Line',
    category: 'Economy',
    pricePerDay: 300,
    seats: 5,
    transmission: 'Automatic',
    bags: 2,
    fuelType: 'Gasoline',
    mpg: '5.0 L/100km',
    rating: 4.6,
    reviewsCount: 110,
    licensePlate: '71255-B-07',
    status: 'maintenance',
    mileage: 67800,
    features: ['Climatisation', 'Bluetooth', 'Caméra de recul', 'Airbag'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/2017%20Kia%20Picanto%20GT-Line%20S%201.2%20Front.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/2017%20Kia%20Picanto%20GT-Line%20S%201.2%20Front.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/2024%20Kia%20Picanto%20(JA)%20Rutesheimer%20Autoschau%202025%20DSC%209198.jpg?width=800',
    ],
    colorName: 'Gris Acier',
    year: 2022,
    highlight: false,
    location: 'Agadir City Center',
    visiteTechniqueExpiry: '2026-06-15',
    assuranceExpiry: '2026-10-20',
    vignetteExpiry: '2026-09-30',
    lastVidangeKm: 60000,
    nextVidangeKm: 65000,
  },
  {
    id: 'car-7',
    name: 'Hyundai i10',
    brand: 'Hyundai',
    model: 'i10',
    category: 'Economy',
    pricePerDay: 300,
    seats: 5,
    transmission: 'Automatic',
    bags: 2,
    fuelType: 'Gasoline',
    mpg: '4.9 L/100km',
    rating: 4.7,
    reviewsCount: 68,
    licensePlate: '82314-A-52',
    status: 'available',
    mileage: 31200,
    features: ['Climatisation', 'Bluetooth', 'Vitres électriques', 'Airbag'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Hyundai%20i10%20(AC3%3B%202019).jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/Hyundai%20i10%20(AC3%3B%202019).jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/2023%20Hyundai%20i10%20(AC3)%20Autofr%C3%BChling%20Ulm%20IMG%209349.jpg?width=800',
    ],
    colorName: 'Blanc Polar',
    year: 2023,
    highlight: false,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-02-11',
    assuranceExpiry: '2027-01-10',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 25000,
    nextVidangeKm: 35000,
  },
  {
    id: 'car-8',
    name: 'Hyundai Accent',
    brand: 'Hyundai',
    model: 'Accent',
    category: 'Economy',
    pricePerDay: 300,
    seats: 5,
    transmission: 'Manual',
    bags: 4,
    fuelType: 'Diesel',
    mpg: '4.6 L/100km',
    rating: 4.8,
    reviewsCount: 94,
    licensePlate: '91027-B-29',
    status: 'available',
    mileage: 96400,
    features: ['Climatisation', 'Grand coffre', 'Régulateur de vitesse', 'Bluetooth'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/2012%20Hyundai%20Accent%20(RB)%20Premium%20sedan%20(2018-10-01)%2001.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/2012%20Hyundai%20Accent%20(RB)%20Premium%20sedan%20(2018-10-01)%2001.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/00%20HYUNDAI%20ACCENT%20WIT%201.jpg?width=800',
    ],
    colorName: 'Blanc',
    year: 2021,
    highlight: false,
    location: 'Agadir City Center',
    visiteTechniqueExpiry: '2026-12-05',
    assuranceExpiry: '2026-11-15',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 90000,
    nextVidangeKm: 100000,
  },
  {
    id: 'car-9',
    name: 'Peugeot 208',
    brand: 'Peugeot',
    model: '208 GT-Line',
    category: 'Economy',
    pricePerDay: 280,
    seats: 5,
    transmission: 'Manual',
    bags: 2,
    fuelType: 'Diesel',
    mpg: '4.0 L/100km',
    rating: 4.9,
    reviewsCount: 115,
    licensePlate: '105486-A-61',
    status: 'available',
    mileage: 41700,
    features: ['Climatisation auto', 'i-Cockpit 3D', 'Caméra de recul', 'Toit panoramique'],
    imageType: 'toyota_corolla',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Peugeot%20208%20PureTech%20130%20EAT8%20Allure%20GT-Line%20(II)%20%E2%80%93%20f%2017102021.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/Peugeot%20208%20PureTech%20130%20EAT8%20Allure%20GT-Line%20(II)%20%E2%80%93%20f%2017102021.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Peugeot%20208%20PureTech%20130%20EAT8%20Allure%20GT-Line%20(II)%20%E2%80%93%20h%2017102021.jpg?width=800',
    ],
    colorName: 'Jaune Faro',
    year: 2023,
    highlight: true,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-04-22',
    assuranceExpiry: '2027-03-01',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 35000,
    nextVidangeKm: 45000,
  },
  {
    id: 'car-10',
    name: 'Dacia Jogger',
    brand: 'Dacia',
    model: 'Jogger 7 places',
    category: 'Van',
    pricePerDay: 400,
    seats: 7,
    transmission: 'Manual',
    bags: 2,
    fuelType: 'Diesel',
    mpg: '5.2 L/100km',
    rating: 4.9,
    reviewsCount: 73,
    licensePlate: '112903-B-14',
    status: 'available',
    mileage: 27800,
    features: ['7 places', 'Climatisation', 'Grand coffre modulable', 'Barres de toit'],
    imageType: 'hyundai_tucson',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/2024%20Dacia%20Jogger%20Hybrid%20GIMS%202024%201X7A2413.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/2024%20Dacia%20Jogger%20Hybrid%20GIMS%202024%201X7A2413.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Dacia%20Jogger%20IAA%202021%201X7A0140.jpg?width=800',
    ],
    colorName: 'Gris Schiste',
    year: 2024,
    highlight: false,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-08-30',
    assuranceExpiry: '2027-06-15',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 20000,
    nextVidangeKm: 30000,
  },
  {
    id: 'car-11',
    name: 'Kia Sportage',
    brand: 'Kia',
    model: 'Sportage',
    category: 'SUV',
    pricePerDay: 550,
    seats: 5,
    transmission: 'Automatic',
    bags: 5,
    fuelType: 'Diesel',
    mpg: '5.8 L/100km',
    rating: 4.9,
    reviewsCount: 52,
    licensePlate: '120755-A-77',
    status: 'available',
    mileage: 15600,
    features: ['4x4', 'Toit panoramique', 'Sièges cuir', 'Caméra 360°'],
    imageType: 'hyundai_tucson',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Kia%20Sportage%20(NQ5)%201X7A0326.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/Kia%20Sportage%20(NQ5)%201X7A0326.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Kia%20Sportage%20(NQ5)%201X7A0328.jpg?width=800',
    ],
    colorName: 'Gris Céladon',
    year: 2024,
    highlight: false,
    location: 'Agadir Airport (AGA)',
    visiteTechniqueExpiry: '2027-10-12',
    assuranceExpiry: '2027-09-01',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 10000,
    nextVidangeKm: 20000,
  },
  {
    id: 'car-12',
    name: 'VW T-Roc',
    brand: 'Volkswagen',
    model: 'T-Roc',
    category: 'SUV',
    pricePerDay: 700,
    seats: 5,
    transmission: 'Automatic',
    bags: 4,
    fuelType: 'Diesel',
    mpg: '5.5 L/100km',
    rating: 5.0,
    reviewsCount: 41,
    licensePlate: '131482-B-83',
    status: 'available',
    mileage: 34900,
    features: ['4Motion', 'Toit ouvrant', 'Digital Cockpit', 'Jantes 19 pouces'],
    imageType: 'hyundai_tucson',
    imageUrl: 'https://commons.wikimedia.org/wiki/Special:FilePath/Volkswagen%20T-Roc%20(2021)%201X7A0330.jpg?width=800',
    galleryImages: [
      'https://commons.wikimedia.org/wiki/Special:FilePath/Volkswagen%20T-Roc%20(2021)%201X7A0330.jpg?width=800',
      'https://commons.wikimedia.org/wiki/Special:FilePath/Volkswagen%20T-Roc%20(2021)%201X7A0333.jpg?width=800',
    ],
    colorName: 'Blanc Pur',
    year: 2023,
    highlight: false,
    location: 'Agadir City Center',
    visiteTechniqueExpiry: '2027-05-17',
    assuranceExpiry: '2027-04-10',
    vignetteExpiry: '2026-12-31',
    lastVidangeKm: 30000,
    nextVidangeKm: 40000,
  },
];

// Demonstration clients. Phones, emails, and identity numbers are fictional.
export const INITIAL_CLIENTS: RentalClient[] = [
  {
    id: 'CUST-01',
    name: 'Yassine El Amrani',
    email: 'yassine.elamrani@example.com',
    phone: '+212600000001',
    licenseNumber: 'DEMO-MA-4588210',
    cinPassport: 'DEMO CIN AE294810',
    address: 'Hay Al Massira, Agadir',
    riskLevel: 'clean',
    rentalsCount: 14,
    totalSpent: 34200,
    createdAt: '2025-06-12T10:00:00Z',
  },
  {
    id: 'CUST-02',
    name: 'Salma Bennani',
    email: 'salma.bennani@example.com',
    phone: '+212600000002',
    licenseNumber: 'DEMO-MA-3920144',
    cinPassport: 'DEMO CIN BB102938',
    address: 'Guéliz, Marrakech',
    riskLevel: 'clean',
    rentalsCount: 9,
    totalSpent: 21900,
    createdAt: '2025-08-03T10:00:00Z',
  },
  {
    id: 'CUST-03',
    name: 'Omar Chraibi',
    email: 'omar.chraibi@example.com',
    phone: '+212600000003',
    licenseNumber: 'DEMO-MA-5109931',
    cinPassport: 'DEMO Passport MA883102',
    address: 'Maârif, Casablanca',
    riskLevel: 'watch',
    riskNote: 'Returned 2 days late in September — extension unpaid 3 days.',
    rentalsCount: 6,
    totalSpent: 14500,
    createdAt: '2025-09-20T10:00:00Z',
  },
  {
    id: 'CUST-04',
    name: 'Karim Tazi',
    email: 'karim.tazi@example.com',
    phone: '+212600000004',
    licenseNumber: 'DEMO-MA-1102773',
    cinPassport: 'DEMO CIN CD556120',
    address: 'Agdal, Rabat',
    riskLevel: 'blacklisted',
    riskNote: 'Unpaid damage (pare-choc avant) — 4500 DH outstanding. Do not rent.',
    rentalsCount: 3,
    totalSpent: 8900,
    createdAt: '2025-04-11T10:00:00Z',
  },
  {
    id: 'CUST-05',
    name: 'Nadia El Fassi',
    email: 'nadia.elfassi@example.com',
    phone: '+212600000005',
    licenseNumber: 'DEMO-MA-7301440',
    cinPassport: 'DEMO CIN EE778899',
    address: 'Tanger Marina, Tanger',
    riskLevel: 'clean',
    rentalsCount: 18,
    totalSpent: 41000,
    createdAt: '2025-02-28T10:00:00Z',
  },
];

export const INITIAL_EXPENSES: FleetExpense[] = [
  { id: 'EXP-01', vehicleId: 'car-1', category: 'maintenance', label: 'Vidange + filtres', amount: 850, date: '2026-09-12' },
  { id: 'EXP-02', vehicleId: 'car-3', category: 'assurance', label: 'Assurance annuelle', amount: 5200, date: '2026-01-15' },
  { id: 'EXP-03', category: 'cleaning', label: 'Nettoyage intérieur lot', amount: 600, date: '2026-10-02' },
  { id: 'EXP-04', vehicleId: 'car-9', category: 'visite', label: 'Visite technique', amount: 350, date: '2026-07-20' },
];

export const INITIAL_BOOKINGS: Booking[] = [
  {
    id: 'DX-94021',
    vehicleId: 'car-4',
    vehicleName: 'Renault Clio 5',
    vehicleCategory: 'Economy',
    vehiclePrice: 300,
    customerName: 'Yassine El Amrani',
    customerEmail: 'yassine.elamrani@gmail.com',
    customerPhone: '+212661234567',
    driverLicense: 'MA-4588210',
    pickupLocation: 'Agadir Airport (AGA)',
    dropoffLocation: 'Agadir Airport (AGA)',
    pickupDate: '2026-10-18',
    pickupTime: '10:00 AM',
    dropoffDate: '2026-10-22',
    dropoffTime: '10:00 AM',
    rentalDays: 4,
    dailyRate: 300,
    protectionPlan: 'standard',
    protectionPrice: 560,
    selectedAddOns: ['gps'],
    addOnsPrice: 120,
    subtotal: 1880,
    discount: 0,
    totalPrice: 1880,
    avanceAmount: 400,
    cautionAmount: 2000,
    cautionType: 'cash',
    paymentMethod: 'cash',
    status: 'confirmed',
    createdAt: '2026-10-09T14:22:00Z',
  },
  {
    id: 'DX-81944',
    vehicleId: 'car-1',
    vehicleName: 'Dacia Logan',
    vehicleCategory: 'Economy',
    vehiclePrice: 250,
    customerName: 'Salma Bennani',
    customerEmail: 'salma.bennani@gmail.com',
    customerPhone: '+212662345678',
    driverLicense: 'MA-3920144',
    pickupLocation: 'Agadir City Center',
    dropoffLocation: 'Agadir Airport (AGA)',
    pickupDate: '2026-09-02',
    pickupTime: '09:00 AM',
    dropoffDate: '2026-09-05',
    dropoffTime: '06:00 PM',
    rentalDays: 3,
    dailyRate: 250,
    protectionPlan: 'basic',
    protectionPrice: 0,
    selectedAddOns: [],
    addOnsPrice: 0,
    subtotal: 750,
    discount: 0,
    totalPrice: 750,
    avanceAmount: 750,
    cautionAmount: 1500,
    cautionType: 'cash',
    paymentMethod: 'cash',
    status: 'completed',
    createdAt: '2026-08-25T11:00:00Z',
  },
];

export const RENTAL_LOCATIONS: RentalLocation[] = [
  {
    id: 'loc-mia',
    name: 'Miami International Airport',
    city: 'Miami',
    state: 'FL',
    code: 'MIA',
    address: '3900 NW 25th St, Miami, FL 33142',
    phone: '+1 (305) 555-0199',
    hours: 'Open 24/7 (Desk & Fast-Return)',
    fleetCount: 64,
    isAirport: true,
  },
  {
    id: 'loc-lax',
    name: 'Los Angeles International Airport',
    city: 'Los Angeles',
    state: 'CA',
    code: 'LAX',
    address: '9020 Aviation Blvd, Inglewood, CA 90301',
    phone: '+1 (310) 555-0144',
    hours: 'Open 24/7 (Shuttle Every 8 mins)',
    fleetCount: 88,
    isAirport: true,
  },
  {
    id: 'loc-jfk',
    name: 'John F. Kennedy International',
    city: 'New York',
    state: 'NY',
    code: 'JFK',
    address: 'Federal Circle, Jamaica, NY 11430',
    phone: '+1 (718) 555-0182',
    hours: 'Open 24/7 (AirTrain Station C)',
    fleetCount: 72,
    isAirport: true,
  },
  {
    id: 'loc-ord',
    name: 'Chicago O\'Hare International',
    city: 'Chicago',
    state: 'IL',
    code: 'ORD',
    address: '10255 W Zemke Blvd, Chicago, IL 60666',
    phone: '+1 (773) 555-0130',
    hours: '24 Hours Multi-Modal Terminal',
    fleetCount: 52,
    isAirport: true,
  },
  {
    id: 'loc-mco',
    name: 'Orlando International Airport',
    city: 'Orlando',
    state: 'FL',
    code: 'MCO',
    address: '1 Jeff Fuqua Blvd, Orlando, FL 32827',
    phone: '+1 (407) 555-0177',
    hours: 'Open 24/7 (Terminal A & B)',
    fleetCount: 60,
    isAirport: true,
  },
  {
    id: 'loc-sfo',
    name: 'San Francisco International',
    city: 'San Francisco',
    state: 'CA',
    code: 'SFO',
    address: '780 N McDonnell Rd, San Francisco, CA 94128',
    phone: '+1 (650) 555-0155',
    hours: 'Open 24/7 (AirTrain Blue Line)',
    fleetCount: 48,
    isAirport: true,
  }
];

export const RENTAL_ADD_ONS: RentalAddOn[] = [
  {
    id: 'gps',
    name: 'GPS Navigation',
    description: 'Guidage vocal virage par virage avec trafic en temps réel.',
    pricePerDay: 30,
  },
  {
    id: 'extra-driver',
    name: 'Conducteur supplémentaire',
    description: 'Partagez le volant en toute sérénité. Les deux conducteurs sont couverts.',
    pricePerDay: 50,
  },
  {
    id: 'child-seat',
    name: 'Siège enfant / Rehausseur',
    description: 'Siège auto homologué, propre et adapté à l’âge de l’enfant.',
    pricePerDay: 40,
  },
  {
    id: 'toll-pass',
    name: 'Pass Autoroute Maroc',
    description: 'Traversez les péages sans monnaie avec le badge électronique.',
    pricePerDay: 30,
  }
];

export const FAQS = [
  {
    q: 'What do I need to rent a vehicle with fleetava?',
    a: 'You will need a valid driver\'s license (held for at least 1 year), a valid debit or major credit card in your name, and a government-issued photo ID or passport. International travelers should provide an International Driving Permit if their license is not in the English alphabet.'
  },
  {
    q: 'How does your Free Cancellation policy work?',
    a: 'You can cancel or modify your reservation anytime with 100% full refund up to 1 hour before scheduled pickup. No cancellation fees, no hidden penalties.'
  },
  {
    q: 'Are mileage limits enforced on car rentals?',
    a: 'All our standard passenger vehicles come with unlimited miles across all states, so you can explore freely without counting miles or worrying about surcharges.'
  },
  {
    q: 'Can I pick up in one city and drop off in another?',
    a: 'Yes! We support convenient one-way rentals between our major airport hubs (e.g., Miami, Orlando, LAX, JFK) with transparent one-way drop charges clearly shown before checkout.'
  },
  {
    q: 'What insurance and protection packages are included?',
    a: 'Every fleetava booking includes standard third-party liability coverage. You can upgrade to our Premium Full-Shield package for $24/day for $0 deductible collision damage waiver (CDW), tire, glass, and theft protection.'
  }
];
